import Address from './Address'
import BirthDate from './BirthDate'
import City from './City'
import Country from './Country'
import Email from './Email'
import EmailConfirmation from './EmailConfirmation'
import FirstName from './FirstName'
import Gender from './Gender'
import LastName from './LastName'
import Password from './Password'
import PasswordConfirmation from './PasswordConfirmation'
import Phone from './Phone'
import State from './State'
import Submit from './Submit'
import Zip from './Zip'
import Subscribe from './Subscribe'
import SmsSubscribe from './SmsSubscribe'

Vue.component(Address.name, Address)
Vue.component(BirthDate.name, BirthDate)
Vue.component(City.name, City)
Vue.component(Country.name, Country)
Vue.component(Email.name, Email)
Vue.component(EmailConfirmation.name, EmailConfirmation)
Vue.component(FirstName.name, FirstName)
Vue.component(Gender.name, Gender)
Vue.component(LastName.name, LastName)
Vue.component(Password.name, Password)
Vue.component(PasswordConfirmation.name, PasswordConfirmation)
Vue.component(Phone.name, Phone)
Vue.component(State.name, State)
Vue.component(Submit.name, Submit)
Vue.component(Zip.name, Zip)
Vue.component(Subscribe.name, Subscribe)
Vue.component(SmsSubscribe.name, SmsSubscribe)
